import { SerializedFile } from "@repo/models";

import { UploadedFile } from "./backgroundCheck";
import { RepSegment } from "./repSegment";

export default interface DrugTest {
	drugTestId: number;
	createdOn: Date;
	representativeId: number;
	requestedBy: number;
	requestedByName: string;
	status: string;
	type: DrugTestTypeEnum;

	conductedOn: Date;
	providerName: string;
	result: DrugTestResultEnum;
	resultId: DrugTestResultEnum;
	resultName: string;
	resultSummary: string;
	specimenId: string;
	resultDocumentId: number;
	consentDocument: SerializedFile[];
	consentDocumentUploaded: UploadedFile[];
	resultDocument: SerializedFile[];
	resultDocumentUploaded: UploadedFile[];

	secondTestConductedOn: Date;
	secondTestProviderName: string;
	secondTestResult: DrugTestResultEnum;
	secondTestResultId: DrugTestResultEnum;
	secondTestResultName: string;
	secondTestSpecimenId: string;
	secondTestResultDocumentId: number;
	secondTestResultDocument: SerializedFile[];
	secondTestResultDocumentUploaded: UploadedFile[];

	exceptionRequested: boolean;
	exceptionReason: string;
	exceptionStatus: ExceptionStatus;
	comments: string;

	onboardingSegmentsId: number[];
	onboardingSegments: RepSegment[];

	//Client-Side Only
	responseStarted: boolean;
	onboardingSessionId: number;
	expired?: boolean;
}

export enum DrugTestTypeEnum {
	Quick = 1,
	Lab = 2,
}

export enum DrugTestResultEnum {
	Positive = 1,
	Negative = 2,
}

export enum ExceptionStatus {
	Approved = 3,
	Denied = 2,
	Pending = 1,
}
